var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M48.0097 46.7495H35.6907V33.9626H40.0718L29.9984 20.6702L19.9245 33.9626H24.3065V46.7495H7.76014C-2.58624 46.7495 -2.58719 30.9805 7.76014 30.9805C7.24536 25.3206 10.1838 21.8832 15.6884 21.8832C16.8547 21.8832 17.9633 22.133 18.9608 22.5834C21.5264 9.26613 41.2488 9.55144 43.3857 22.9728C61.3773 15.7735 67.4106 46.7494 48.01 46.7494L48.0097 46.7495Z","fill":"#2665F6"}));
}

Cloud.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Cloud;

Cloud.default = Cloud;
